import { __assign, __read } from "tslib";
/**
 * @description
 * convert parameter seem like {prefixFilter: val1, prefixFiltrate: val2}
 * to {prefixFilter: val2, prefixFiltrate: val1}
 */
export function filterTransform(parameter) {
    var finalParameter = __assign({}, parameter);
    var reg = new RegExp(/^(f|[\S]+F)(ilter|iltrate)$/);
    var keys = {};
    var mapper = { iltrate: 'ilter', ilter: 'iltrate' };
    Object.entries(parameter).forEach(function (_a) {
        var _b = __read(_a, 2), k = _b[0], v = _b[1];
        if (reg.test(k))
            keys[k] = v;
    });
    Object.keys(keys).forEach(function (k) {
        delete finalParameter[k];
    });
    Object.keys(keys).forEach(function (k) {
        var _a;
        if ((k.endsWith('iltrate') && typeof keys[k] !== 'function') ||
            (k.endsWith('ilter') && typeof keys[k] === 'function')) {
            var key = k.replace(reg, function (match, p1, p2) { return "".concat(p1).concat(mapper[p2]); });
            Object.assign(finalParameter, (_a = {}, _a[key] = keys[k], _a));
        }
    });
    return finalParameter;
}
//# sourceMappingURL=filter-transform.js.map